import RequestAbstract from "../abstract";

export default class Files extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/files";
    }
    

    getFile = async (name) => {
        return this.loadWithAuth(`${this.link}/get/${name}`, {
            method: 'GET'
        },
        { fileDownload: true });
    };
    upload = async (file) => {
        return this.loadWithAuth(this.link + '/upload', {
            method: 'POST',
            body: file
        }, { fileUpload: true });
    };
    downloadByUuid = async (uuid) => {
        return this.loadBinary(`${this.link}/download/uuid/${uuid}`, {
            method: 'GET'
        });
    };
    // downloadByToken = async (token) => {
    //     return this.load(`${this.link}/download/token/${token}`, {
    //         method: 'GET'
    //     });
    // };
    openByTokenInNewTab = (token) => {
        const url = `/${this.link}/download/token/${encodeURIComponent(token)}`;
        console.log('open url', url);
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    getTokenByUuid = async (uuid) => {
        return this.loadWithAuth(`${this.link}/token/${uuid}`, {
            method: 'GET'
        });
    };

}
